module.exports = __webpack_public_path__ + "img/sphtx.a9a8d840.svg";